import BannerSection from './BannerSection';
import HiringProcessSection from './HiringProcessSection';
import FAQSection from './FAQSection';
import ServicesSection from './ServicesSection';
import EmoteEngineer from './EmoteEngineer';
import { useSelector } from 'react-redux';
import SimplifySection from '../common/SimplifySection';

const TechHire = () => {
  const { developerListByRoleSkills } = useSelector(state => state.home);
  const { selected_skill } = useSelector(state => state.common)
  
  return (
    <main className="mainCon">
      <BannerSection {...{ selected_skill }} />
      <HiringProcessSection {...{ selected_skill }} />
      <FAQSection {...{ selected_skill }} />
      <ServicesSection />
      <EmoteEngineer {...{ selected_skill }} />
      <SimplifySection />
    </main>
  );
};
export default TechHire;